import { API_BASE_URL } from './apiConfig';

export const login = async (username, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({ username, password }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }

    if (!data.result) {
      throw new Error('No token received');
    }

    // Store token and related data in cookies
    setCookie('authToken', data.result, 7); // Expires in 7 days
    setCookie('username', username, 7);
    setCookie('lastActivity', Date.now().toString(), 7);
    
    return data.result;
  } catch (error) {
    // Clear cookies on error
    removeCookie('authToken');
    removeCookie('username');
    removeCookie('lastActivity');
    console.error('Login error:', error);
    throw new Error(error.message || 'Login failed');
  }
};

export const logout = async () => {
  const token = getCookie('authToken');
  const username = getCookie('username');

  try {
    if (token && username) {
      const response = await fetch(`${API_BASE_URL}/admin/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ username }),
      });

      if (!response.ok) {
        throw new Error('Logout failed');
      }
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    // Clear cookies regardless of API response
    removeCookie('authToken');
    removeCookie('username');
    removeCookie('lastActivity');
  }
};

export const validateToken = async () => {
  const token = getCookie('authToken');
  console.log('Validating token, cookies:', {
    authToken: token,
    username: getCookie('username'),
    lastActivity: getCookie('lastActivity'),
  });

  if (!token) {
    return false;
  }

  // Client-side expiration check
  const lastActivity = getCookie('lastActivity');
  const idleTimeout = 30 * 60 * 1000; // 30 minutes
  
  if (lastActivity && Date.now() - parseInt(lastActivity, 10) > idleTimeout) {
    console.log('Token expired due to inactivity');
    removeCookie('authToken');
    removeCookie('username');
    removeCookie('lastActivity');
    return false;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/validate-token?token=${encodeURIComponent(token)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    
    const data = await response.json();
    if (!data.success || !data.result) {
      console.log('Token validation failed:', data);
      removeCookie('authToken');
      removeCookie('username');
      removeCookie('lastActivity');
      return false;
    }
    console.log('Token validation successful');
    return true;
  } catch (error) {
    console.error('Token validation error:', error);
    removeCookie('authToken');
    removeCookie('username');
    removeCookie('lastActivity');
    return false;
  }
};

function setCookie(name, value, days) {
  const expires = days ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}` : '';
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Lax; Secure`; // Add Secure if using HTTPS
}

function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return null;
}

function removeCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
}